import { Component, OnInit } from '@angular/core';
import { SentryService } from '@lmc-app/core/services/sentry.service';

@Component({
	selector: 'app-debugging',
	templateUrl: './debugging.component.html',
	styleUrls: ['./debugging.component.scss'],
})
export class DebuggingComponent implements OnInit {
	constructor(private sentryService: SentryService) {}

	ngOnInit(): void {}

	/**
	 * Throw a test error that will be automatically caught by Sentry ErrorHandler
	 */
	throwTestError(showReport: boolean): void {
		this.sentryService.captureException(
			new Error('Sentry Testing Error'),
			showReport
		);
	}
}
